/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @version 1.26.0
 * @since 1.22.0
 */

import EFormValidation from '../../form/const/formValidation';
import { TFileError, ISortedRejectedFiles } from '../types';

export const sortRejectedFiles = (rejectedFiles: Map<string, TFileError>) => {
    const sortedFiles: ISortedRejectedFiles = {
        rejectedFilesFormatIncorrectItems: [],
        rejectedFilesMaxSizesItems: [],
        rejectedFilesExistsItems: [],
        rejectedFilesEmptyDataItems: [],
        rejectedFilesNameTooLongItems: [],
        rejectedFilesUnknownErrorItems: [],
        rejectedFilesUploadUnavailableItems: [],
    };

    Array.from(rejectedFiles, (fileData) => fileData[1]).forEach((el) => {
        switch (el.error) {
            case EFormValidation.fileFormatIncorrect:
                sortedFiles.rejectedFilesFormatIncorrectItems.push(el.file);
                break;
            case EFormValidation.fileSizeExceeded:
                sortedFiles.rejectedFilesMaxSizesItems.push(el.file);
                break;
            case EFormValidation.fileDataEmpty:
                sortedFiles.rejectedFilesEmptyDataItems.push(el.file);
                break;
            case EFormValidation.fileNotFound:
                sortedFiles.rejectedFilesUnknownErrorItems.push(el.file);
                break;
            case EFormValidation.fileNameTooLong:
                sortedFiles.rejectedFilesNameTooLongItems.push(el.file);
                break;
            case EFormValidation.fileExist:
                sortedFiles.rejectedFilesExistsItems.push(el.file);
                break;
            case EFormValidation.fileUploadUnavailable:
                sortedFiles.rejectedFilesUploadUnavailableItems.push(el.file);
                break;
            default:
                sortedFiles.rejectedFilesUnknownErrorItems.push(el.file);
        }
    });
    return sortedFiles;
};
